import React from 'react';
import { faRedo } from '@fortawesome/free-solid-svg-icons';
import { strings } from '../../../resources/strings';
import { AssemblerManagementOption } from '../../../enums/AssemblerManagementOption';
import { AssemblerOrder } from '../../../models/AssemblerOrder';
import { Button } from '../../../common-components/Button/Button';
import { DropdownButton, DropdownButtonColor } from '../../../common-components/DropdownButton/DropdownButton';
import { Container, StaticField, Title, Value, Options, TabsContainer } from './styles';

interface IHeaderProps {
  assemblerOrder?: AssemblerOrder | null;
  loading?: boolean;
  update: () => void;
  applyAssemblerOperation: (operation: AssemblerManagementOption) => void;
}

const Header: React.FC<IHeaderProps> = ({
  children,
  assemblerOrder,
  loading,
  update,
  applyAssemblerOperation
}) => {

  return (
    <>
      <Container>
        <StaticField width='85px'>
          <Title>{strings.Number}</Title>
          <Value bold data-id={assemblerOrder?.order.id}>{assemblerOrder?.order.number}</Value>
        </StaticField>
        <Options>
          {loading ? null : (
            <>
              <Button icon={faRedo} marginRight='3px' title={strings.Update} click={update} />
              <DropdownButton
                items={[
                  {
                    key: AssemblerManagementOption.PrintTSO,
                    text: `TSO`
                  },
                  {
                    key: AssemblerManagementOption.InformReceipt,
                    text: `Informar Recebimento`
                  },
                  {
                    key: AssemblerManagementOption.InformAssemblyStart,
                    text: `Informar Início Montagem`
                  },
                  {
                    key: AssemblerManagementOption.InformCompletedAssembly,
                    text: `Informar Conclusão Montagem`
                  },
                  {
                    key: AssemblerManagementOption.InformSendToStore,
                    text: `Informar Envio Loja`
                  },
                  {
                    key: AssemblerManagementOption.AddNote,
                    text: `Adicionar Observação`
                  }
                ]}
                defaultStyle={true}
                small={true}
                buttonColor={DropdownButtonColor.Success}
                text={''}
                clickItem={(key) => applyAssemblerOperation && applyAssemblerOperation(key)}
              />
            </>
          )}
        </Options>
      </Container>
      <TabsContainer>
        {children}
      </TabsContainer>
    </>
  );

};

export { Header };